import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function AddProspectInline({ onAdd }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");

  if (!open) {
    return (
      <Button
        variant="secondary"
        className="rounded-full bg-amber-500/90 text-amber-950 hover:bg-amber-500"
        onClick={() => setOpen(true)}
        data-testid="add-prospect-inline-open"
      >
        Add Prospect
      </Button>
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="Prospect name"
        className="bg-white/5 text-slate-100 placeholder:text-slate-400/70 ring-1 ring-white/10"
        data-testid="add-prospect-inline-name"
      />
      <div className="flex gap-2">
        <Button
          className="rounded-full bg-amber-500/90 text-amber-950 hover:bg-amber-500"
          onClick={() => {
            const trimmed = name.trim();
            if (!trimmed) return;
            onAdd?.(trimmed);
            setName("");
            setOpen(false);
          }}
          data-testid="add-prospect-inline-submit"
        >
          Add
        </Button>
        <Button
          variant="secondary"
          className="rounded-full bg-white/10 text-slate-100 ring-1 ring-white/10 hover:bg-white/15"
          onClick={() => {
            setOpen(false);
            setName("");
          }}
          data-testid="add-prospect-inline-cancel"
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
